var hasProp = window.hasProp;
var extend = window.extend;
var NewCertificationStore = window.NewCertificationStore;
var NewCertificationStore,
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
NewCertificationStore = function (superClass) {
  extend(NewCertificationStore, superClass);
  function NewCertificationStore() {
    NewCertificationStore.__super__.constructor.call(this);
    this.dispatcherCallback('certification-create', this.onCertify);
  }
  NewCertificationStore.prototype.hasData = function () {
    return false;
  };
  NewCertificationStore.prototype.loadData = function () {};
  NewCertificationStore.prototype.onCertify = function (payload) {
    var data, error, success, url;
    data = {
      work_id: payload.workId,
      url: payload.url,
      comment: payload.commentBody,
      details: payload.details,
      source: payload.source,
      source_details: payload.sourceDetails
    };
    url = $r.api_v0_certifications_certifications_path;
    success = function (_this) {
      return function (response) {
        _this.notifyCertificationCreated(response);
        return _this.emitChange({
          request: data,
          success: true
        });
      };
    }(this);
    error = function (_this) {
      return function (response) {
        var e, errors;
        $a.admin_log("Error creating certification", response);
        errors = null;
        try {
          errors = JSON.parse(response.responseText).errors || [];
        } catch (error1) {
          e = error1;
          errors = [];
        }
        return _this.emitChange({
          request: data,
          success: false,
          errors: errors
        });
      };
    }(this);
    return this.createAtUrl(url, data, success, error);
  };
  NewCertificationStore.prototype.notifyCertificationCreated = function (certification) {
    if (certification.certifiee_type === 'Work') {
      return Flux.Dispatcher.dispatch({
        actionType: 'work-certification-create',
        certification: certification
      });
    }
  };
  return NewCertificationStore;
}(Flux.Store);
Flux.Certifications.NewCertificationStore = new NewCertificationStore();
window.NewCertificationStore = NewCertificationStore;
window.extend = extend;
window.hasProp = hasProp;